/**
 * @file 文档模块样式
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useCallback, useRef} from 'react';
import {message} from 'antd';

import ReactStickyPolyfill from '../../../../components/react-sticky-polyfill/ReactStickyPolyfill';
import RightMenu from './components/right-menu/RightMenu';
import useRightMenuHooks from './components/right-menu/rightMenuHooks';

import {IDocContainerProps} from './types.d';
import MarkdownContainer from '../../../../components/markdown-container/MarkdownContainer';
import {getCodeBlock} from '../../../../components/markdown-container/CodeBlock';


const DocMarkdownContainer: React.FC<IDocContainerProps> = (props) => {
    const contentDomRef = useRef<HTMLDivElement>(null);
    const rightMenuHooks = useRightMenuHooks(props.text, contentDomRef);

    const onMarkdownCopyClick = useCallback((text?: string) => {
        if (!text) {
            return;
        }
        const text2 = text.length > 20 ? `${text.slice(0, 20)}...` : text;
        message.info(`${text2} 已复制到剪贴板`);
        if (text.indexOf('install paddlepaddle') > -1 || text.indexOf('docker pull') > -1) {
            // 如果点击复制按钮，则触发一次埋点事件
            if ((window as any)._hmt) {
                (window as any)._hmt.push(['_trackEvent', '安装', '快速安装方案生成', '安装执行']);
            }
        }
    }, []);

    return (
        <div className="paddle-install-quick-main">
            <div className="paddle-install-quick-right">
                <ReactStickyPolyfill>
                    <div className="paddle-install-quick-right-menu-wrap">
                        <RightMenu
                            {...rightMenuHooks}
                        />
                    </div>
                </ReactStickyPolyfill>
            </div>

            <div className="paddle-install-quick-center">
                <div
                    className="paddle-install-quick-content markdown-body"
                    ref={contentDomRef}
                >
                    <MarkdownContainer
                        source={props.text}
                        renderers={{
                            code: getCodeBlock({
                                onCopyClick: onMarkdownCopyClick
                            })
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default DocMarkdownContainer;
